module.exports = __webpack_public_path__ + "img/public-exam.c456e90a.png";